import { iterLines } from './lexer.js';
const CATEGORY_LETTERS = new Set(['W', 'S', 'E', 'Z', 'H', 'V']);
export function parseAt(content) {
    const file = { records: [], unparsed: [] };
    for (const line of iterLines(content)) {
        const body = line.trimmed.trim();
        if (body === '')
            continue;
        // Take DATUM as metadata if it appears bare.
        if (body.startsWith('DATUM ')) {
            file.date = body.slice('DATUM '.length).trim();
            continue;
        }
        // Skip `//` comment-only lines (iterLines already stripped trailing `//`, so a body
        // starting after a `//` strip means the line was all-comment — `body` will be empty).
        // Skip lines starting with `;` — none observed in AT, but be defensive.
        if (body.startsWith(';'))
            continue;
        // Records start with a single-letter category followed by whitespace.
        const m = body.match(/^([A-Z])\s+(\S+)\s*(.*)$/);
        if (!m) {
            // Not a data record (probably a header / continuation comment).
            continue;
        }
        const [, category, code, rest] = m;
        if (!CATEGORY_LETTERS.has(category)) {
            // Unknown leading letter — treat as commentary and skip rather than flag.
            continue;
        }
        const fsws = rest.split(/\s+/).filter((t) => t.length > 0);
        file.records.push({
            category: category,
            code: code,
            fsws,
            comment: line.comment,
        });
    }
    return file;
}
//# sourceMappingURL=at.js.map